import { render, staticRenderFns } from "./AlbumDeleteModal.vue?vue&type=template&id=c37f4f46"
import script from "./AlbumDeleteModal.vue?vue&type=script&lang=ts"
export * from "./AlbumDeleteModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports